import { axios } from 'services/axios';
import { normaliseCatalogueItem as normaliseItem } from 'utils/eightByEightCatalog';

/**
 * Map form fields to the API payload shape.
 * Form → API:
 *   parentId    → parentID
 *   offeringId  → reference1
 *   visibility  → visible (boolean)
 *   rule        → optionalChild (boolean)
 */
const toApiPayload = (fields) => ({
    name: fields.name,
    description: fields.description ?? '',
    sku: fields.sku ?? '',
    parentID: fields.parentId || null,
    reference1: fields.offeringId ?? '',
    reference2: fields.reference2 ?? '',
    reference3: fields.reference3 ?? '',
    visible: fields.visibility === 'visible',
    optionalChild: fields.rule === 'optional',
});

export const getCatalogItems = async (platformId, scope) => {
    const response = await axios.get(`/CatalogItems/${platformId}`, {
        headers: { 'X-RequestScope': scope },
    });
    const items = Array.isArray(response.data) ? response.data : [];
    return {
        status: 200,
        data: items.map((item) => normaliseItem(item, items)),
    };
};

export const getCatalogItemById = async (id, scope) => {
    const response = await axios.get(`/CatalogItem/${id}`, {
        headers: { 'X-RequestScope': scope },
    });
    return { status: 200, data: normaliseItem(response.data) };
};

export const createCatalogItem = async (fields, platformId, scope) => {
    const response = await axios.post(
        '/CatalogItem',
        { ...toApiPayload(fields), platformID: platformId },
        { headers: { 'X-RequestScope': scope } },
    );
    return { status: 200, data: normaliseItem(response.data) };
};

export const updateCatalogItem = async (id, fields, scope) => {
    const response = await axios.put(
        '/CatalogItem',
        { id, ...toApiPayload(fields) },
        { headers: { 'X-RequestScope': scope } },
    );
    return { status: 200, data: normaliseItem(response.data) };
};

export const deleteCatalogItem = async (id, scope) => {
    const response = await axios.delete(`/CatalogItem/${id}`, {
        headers: { 'X-RequestScope': scope },
    });
    return { status: 200, data: response.data };
};
